import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Random Number Generator Step
 *
 * Generates a random integer between min and max (inclusive).
 * Useful for testing conditional branching workflows.
 */
export const randomNumberGeneratorStep = defineStepConfig({
  type: "random_number_generator",
  name: "Random Number Generator",
  description: "Generates a random integer between min and max (inclusive)",
  category: "Utility",

  inputSchema: z.object({}),

  outputSchema: z.object({
    value: z
      .number()
      .describe("Random integer between min and max (inclusive)"),
  }),

  configSchema: z.object({
    min: z
      .number()
      .int()
      .prefault(0)
      .describe("Minimum value (inclusive, default 0)"),
    max: z
      .number()
      .int()
      .prefault(10)
      .describe("Maximum value (inclusive, default 10)"),
  }),

  emits: [] as const,
});
